var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsumo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBC00",
    d: "M646.635 618.36 95.425 679a44.428 44.428 0 0 1-24.12-7.131 44.453 44.453 0 0 1-16.39-19.09 44.5 44.5 0 0 1 7.253-47.732C163.352 489.688 374.693 239 570.527 239a213.636 213.636 0 0 1 114.544 33.279c121.195 76.161 83.495 212.962 48.766 289.122a97.167 97.167 0 0 1-35.327 41.163 97.074 97.074 0 0 1-51.875 15.796Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBC00",
    d: "M569.346 179.529c-208.309 0-414.382 228.866-530.348 361.471a43.9 43.9 0 0 1-6.846-27.429 43.867 43.867 0 0 1 11.288-25.909C144.609 372.109 355.859 121 551.608 121a213.219 213.219 0 0 1 114.495 33.335c31.669 19.243 56.479 48.014 70.897 82.218a208.84 208.84 0 0 0-20.593-14.75 275.272 275.272 0 0 0-147.089-42.215"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsumo);
export default __webpack_public_path__ + "static/media/appsumo.7245d3e49aa96471eb240895feac8474.svg";
export { ForwardRef as ReactComponent };